import { defineMessages } from 'react-intl';

export default defineMessages({
    makeAPayment: {
        id: 'billing.make-payment-page.Make a Payment',
        defaultMessage: 'Make a Payment'
    },
    setPaymentSource: {
        id: 'billing.make-payment-page.Set Payment Source',
        defaultMessage: 'Set Payment Source'
    },
    selectInvoicesToPay: {
        id: 'billing.make-payment-page.Select Invoices to Pay',
        defaultMessage: 'Select Invoices to Pay'
    },
    pleaseAllowOneTwoBusinessPaymentProcessing: {
        id: 'billing.make-payment-page.Please allow 1-2 business days for payment processing.',
        defaultMessage: 'Please allow 1-2 business days for payment processing.'
    },
    payNow: {
        id: 'billing.make-payment-page.Pay Now',
        defaultMessage: 'Pay Now'
    },
    paymentOfHasBeenAppliedToYourAccount: {
        id: 'billing.make-payment-page.Payment of x has been applied to your account.',
        defaultMessage: 'Payment of {amountToPay} has been applied to your account.'
    },
    amountToPay: {
        id: 'tdic.billing.make-payment-page.Invoice Subtotal',
        defaultMessage: 'Invoice Subtotal'
    },
    paymentRequestFailed: {
        id: 'billing.make-payment-page.Payment request failed',
        defaultMessage: 'Payment request failed'
    },
    sorryYourPaymentCouldNotBeProcessedAtThisTime: {
        id: 'billing.make-payment-page.Sorry your payment could not be processed at this time',
        defaultMessage: 'Sorry your payment could not be processed at this time'
    },
    noPaymentsAreCurrentlyDue: {
        id: 'billing.make-payment-page.No payments are currently due. Please contact your agent if you have questions about your account balance.',
        defaultMessage: 'No payments are currently due. Please contact your agent if you have questions about your account balance.'
    },
    paymentComplete: {
        id: 'billing.make-payment-page.Payment Complete',
        defaultMessage: 'Payment Complete'
    },
    messageForPaymentComplete: {
        id: 'billing.make-payment-page.Thank you for your payment which is now being processed. The status of your invoice will be updated once payment has been successfully processed.',
        defaultMessage: 'Thank you for your payment which is now being processed. The status of your invoice will be updated once payment has been successfully processed.'
    },
    returnToSummary: {
        id: 'billing.make-payment-page.Return to Summary',
        defaultMessage: 'Return to Summary'
    },
    tncBillingPsf: {
        id: 'tdic.billing.make-payment-page.I agree to the {link} including the billing and payment section and have kept a copy of this authorization for my records.',
        defaultMessage: 'I agree to the {link} including the billing and payment section and have kept a copy of this authorization for my records.'
    },
    tncBillingAch: {
        id: 'tdic.billing.make-payment-page.Autopay.I agree to the {link} including the billing and payment section and have kept a copy of this authorization for my records. I understand this is a one-time payment. I can split my policy payments into convenient monthly payments by enrolling in autopay.',
        defaultMessage: 'I agree to the {link} including the billing and payment section and have kept a copy of this authorization for my records. I understand this is a one-time payment. I can split my policy payments into convenient monthly payments by enrolling in {link1}.'
    },
    tncBilling: {
        id: 'tdic.billing.make-payment-page.I acknowledge the credit card fee above, agree to the {link} including the billing and payment section and have kept a copy of this authorization for my records.',
        defaultMessage: 'I acknowledge the credit card fee above, agree to the {link} including the billing and payment section and have kept a copy of this authorization for my records.'
    },
    termsOfUse: {
        id: 'tdic.billing.make-payment-page.Terms of Use',
        defaultMessage: 'Terms of Use'
    },
    invalidEmail: {
        id: 'tdic.billing.make-payment-page.Please enter a valid email address.',
        defaultMessage: 'Please enter a valid email address.'
    },
    emptyEmail: {
        id: 'tdic.billing.make-payment-page.This is a required field',
        defaultMessage: 'This is a required field'
    },
    payMyBill: {
        id: 'tdic.billing.make-payment-page.Pay My Bill',
        defaultMessage: 'Pay My Bill'
    },
    hasDueinvoicesOnCancelledPolicy: {
        id: 'billing.make-payment-page.Payments for active policies are available to be made through your online account.  Please contact your agent if you have any questions about your account balance or policy status.',
        defaultMessage: 'Payments for active policies are available to be made through your online account.  Please contact your agent if you have any questions about your account balance or policy status.'
    },
    bankAccount: {
        id: 'tdic.billing.make-payment-page.Bank Account',
        defaultMessage: 'Bank Account'
    },
    creditCard: {
        id: 'tdic.billing.make-payment-page.Credit Card',
        defaultMessage: 'Credit Card'
    },
    invoiceLimitTitle: {
        id: 'tdic.billing.make-payment-page.Selection limit reached. ',
        defaultMessage: 'Selection limit reached.'
    },
    invoiceLimitMessage: {
        id: 'tdic.billing.make-payment-page.Complete your transaction with the selected policies and use a separate transaction for additional policies.',
        defaultMessage: 'Complete your transaction with the selected policies and use a separate transaction for additional policies.'
    },
    invoiceOrderTitle: {
        id: 'makePayment.invoiceOrderTitle',
        defaultMessage: 'Invoice selection not allowed'
    },
    invoiceOrderMessage: {
        id: 'makePayment.invoiceOrderMessage',
        defaultMessage: 'Please select earlier due invoices for the same policy before selecting a later invoice.'
    },
    creditCardIns: {
        id: 'tdic.billing.billing-summary.A third-party, percentage-based processing fee applies to all credit card payments.',
        defaultMessage: 'tdic.billing.billing-summary.A third-party, percentage-based processing fee applies to all credit card payments.'
    },
});
